import { useMemo } from "react"
import { useRouteStore } from "@/features/route/state/RouteStore.jsx"
import { selectVesselMeta } from "@/features/route/state/RouteSelectors.jsx"
import {
  isVesselDataComplete,
  mergeVesselMetaIntoSettings,
} from "@/features/voyagePlanner/voyageSettingsFields"

// Resolves a panel's spec vessel: master-data lookup in the RouteStore, the
// request-time merge into the planner settings, and the "real dimensions
// present" compute gate. The caller owns the vessel-id precedence (planner:
// selectedProfile ?? plannerSelectedVessel; RNW: selectedProfile ??
// markedVesselNames[0]).
export default function useSpecVessel({ vesselId, plannerVesselSettings }) {
  const { state } = useRouteStore()
  // Keyed on the vessel slice so waypoint/route dispatches don't churn it.
  const vesselsById = state?.entities?.vesselsById
  const specVesselMeta = useMemo(
    () => selectVesselMeta({ entities: { vesselsById } }, vesselId),
    [vesselsById, vesselId],
  )

  const mergedSettings = useMemo(
    () => mergeVesselMetaIntoSettings(plannerVesselSettings, specVesselMeta),
    [plannerVesselSettings, specVesselMeta],
  )

  return {
    specVesselMeta,
    mergedSettings,
    vesselDataComplete: isVesselDataComplete(mergedSettings),
  }
}
